import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';

export default function BlogPostBigNumbers(bigNumbers) {
  const styles = clsx(
    'blok-blogpost-big-numbers my-16',
  );

  const { Title } = bigNumbers;

  return (
    <div {...storyblokEditable(bigNumbers)} className={styles}>
      {Title && (
      <h3 className="text-center mb-8">{Title}</h3>
      )}
      <div className="flex flex-wrap lg:flex-nowrap lg:justify-between lg:gap-8">
        {bigNumbers?.Numbers?.map((number) => (
          <div key={`${number.Number}-${number.Unit}`} className="w-full md:w-1/2 lg:w-auto my-8 lg:my-0">
            <div className="flex flex-col items-center text-center">
              <span className="text-6xl font-bold">
                {number.Number}
                {number.Unit && (
                <span className="text-3xl">{number.Unit}</span>
                )}
              </span>
              {number.Description && (
              <span className="text-lg mt-4">{number.Description}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
